import { moveToGroup } from "@features/builder/graph/changeGroup/moveToGroup"
import { removeNodesFromGroup, sortNodes } from "@features/builder/graph/helpers"
import { getNodesIntersectingWithGroup } from "@features/builder/graph/intersection"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import { Edge, useReactFlow } from "@xyflow/react"

export type ReactFlowReturnType = ReturnType<typeof useReactFlow<AppNode, Edge<EdgeData>>>

function moveFromGroup({
  selectedNodes,
  allNodes,
  getInternalNode,
}: {
  selectedNodes: AppNode[]
  allNodes: AppNode[]
  getInternalNode: ReactFlowReturnType["getInternalNode"]
}) {
  const updatedNodes = removeNodesFromGroup(selectedNodes, allNodes, getInternalNode)

  return sortNodes(updatedNodes)
}

export function changeGroup({
  selectedNodes,
  allNodes,
  intersecting,
  getInternalNode,
}: {
  intersecting: ReturnType<typeof getNodesIntersectingWithGroup>
  selectedNodes: AppNode[]
  allNodes: AppNode[]
  getInternalNode: ReactFlowReturnType["getInternalNode"]
}) {
  return intersecting.group
    ? moveToGroup({ allNodes, intersecting, getInternalNode })
    : moveFromGroup({ selectedNodes, allNodes, getInternalNode })
}
